import { render, staticRenderFns } from "./ServerExcelDownLoadIframe.vue?vue&type=template&id=92403222&"
import script from "./ServerExcelDownLoadIframe.vue?vue&type=script&lang=ts&"
export * from "./ServerExcelDownLoadIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports